import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Homepage: React.FC = () => {
    const navigate = useNavigate();

    useEffect(() => {
        navigate('/agency');
    }, [navigate]);

    return null;
};

export default Homepage;
